export function formatMoney(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  return n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function formatMonthLabel(monthKey) {
  if (!monthKey) return "Unknown period";
  const [y, m] = String(monthKey).split("-");
  const d = new Date(Number(y), Number(m) - 1, 1);
  if (Number.isNaN(d.getTime())) return monthKey;
  return d.toLocaleDateString("en-IN", { month: "long", year: "numeric" });
}

export function shortId(id) {
  if (!id) return "";
  const s = String(id);
  return s.length <= 8 ? s.toUpperCase() : `${s.slice(0, 8)}…`;
}

/** Unified badge for run + lifecycle + execution. */
export function resolveRunStatus(run) {
  const lifecycle = String(run?.lifecycle_status || "").toLowerCase();
  const execution = String(run?.execution_status || run?.status || "draft").toLowerCase();
  const runStatus = String(run?.status || "").toLowerCase();

  if (lifecycle === "locked") {
    return { key: "locked", label: "Locked", className: "bg-slate-800 text-white border-slate-700" };
  }
  if (execution === "running" || execution === "queued") {
    return { key: execution, label: execution === "queued" ? "Queued" : "Running", className: "bg-blue-100 text-blue-800 border-blue-200" };
  }
  // Processed runs are final — do not show "awaiting approve".
  if (execution === "completed" || execution === "processed" || runStatus === "processed") {
    return { key: "completed", label: "Processed", className: "bg-green-100 text-green-800 border-green-200" };
  }
  if (execution === "failed") {
    return { key: "failed", label: "Failed", className: "bg-red-100 text-red-800 border-red-200" };
  }
  if (execution === "partial_success") {
    return { key: "partial", label: "Partial", className: "bg-amber-100 text-amber-900 border-amber-200" };
  }
  if (lifecycle === "approved") {
    return { key: "approved", label: "Approved", className: "bg-emerald-100 text-emerald-800 border-emerald-200" };
  }
  if (lifecycle === "verified") {
    return { key: "verified", label: "Verified", className: "bg-teal-100 text-teal-800 border-teal-200" };
  }
  return { key: "draft", label: "Draft", className: "bg-slate-100 text-slate-700 border-slate-200" };
}

/** True when a processed run can create a salary disbursement batch. */
export function isDisbursementEligibleRun(run) {
  const status = String(run?.status || "").toLowerCase();
  const execution = String(run?.execution_status || "").toLowerCase();
  const processed = status === "processed" || execution === "completed" || execution === "processed";
  if (!processed) return false;
  const lifecycle = String(run?.lifecycle_status || "").toLowerCase();
  // Backend auto-approves draft/verified on batch create; locked-only orgs still need lock.
  return lifecycle === "approved" || lifecycle === "locked" || lifecycle === "verified" || lifecycle === "draft" || !lifecycle;
}

export function periodStatusBadge(status) {
  const s = String(status || "open").toLowerCase();
  if (s === "closed") return { label: "Closed", className: "bg-slate-200 text-slate-800" };
  if (s === "locked") return { label: "Locked", className: "bg-slate-800 text-white" };
  return { label: "Open", className: "bg-indigo-100 text-indigo-800" };
}
